

import { FormInput } from "@/components/Inputs/FormInput";
import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { SecondaryButton } from "@/components/Buttons/SecondaryButton";
import { Spacing } from "@/components/Spacing/Spacing";
import { Link } from "react-router-dom";
import { useTranslations } from "next-intl";
import { useResetPasswordForm } from "./useResetPasswordForm";

/**
 * ResetPasswordForm component - Handles the password reset form UI and interactions
 * Uses the useResetPasswordForm hook for state management and form handling
 * @returns Password reset form UI with email input and action buttons
 */
export default function ResetPasswordForm() {
  // Get translations for the reset password form UI
  const t = useTranslations("resetPassword");

  // Get form state and handlers from the custom hook
  const {
    prefetch,
    formData,
    errors,
    isLoading,
    handleInputChange,
    handleSubmit,
    rateLimited,
  } = useResetPasswordForm();

  return (
    <form onSubmit={handleSubmit} noValidate className="w-full">
      {/* L7-REVAL — `noValidate` so the app's OWN validation is what runs.
          Commit 4366f35a switched this email field text→email. The browser's
          native HTML5 email constraint then blocked the form submit BEFORE
          onSubmit→handleSubmit, so validateEmail never ran and the styled,
          translated "Invalid email address" never rendered — the user saw only
          the browser's native bubble, in the BROWSER's locale, unstyled, and
          positioned by the browser.
          Kept as type="email" rather than reverted to text: the type is what
          gives mobile users the @/. keyboard and the right autofill hint. It
          is the native VALIDATION that had to go, not the input type. Every
          form here renders its own `error=` for the field, so nothing is left
          unvalidated. */}
      {/* Email input field */}
      <FormInput
        autoComplete={true}
        id="email"
        type="email"
        inputProps={{ autoCapitalize: "none", autoCorrect: "off", spellCheck: false }}
        value={formData.email}
        label={t("email")}
        error={errors.email}
        onChangeAction={(value) => handleInputChange("email", value)}
      />

      {/* Vertical spacing before buttons */}
      <Spacing height="h-6" />

      {/* Submit button - shows loading state during submission */}
      <PrimaryButton
        onHover={prefetch}
        type="submit"
        text={t("sendOtp")}
        size="small"
        disabled={isLoading || rateLimited}
        loading={isLoading}
      />

      {/* Vertical spacing between buttons */}
      <Spacing height="h-3" />

      {/* Cancel button - returns to login page */}
      <Link to="/auth/login">
        <SecondaryButton text={t("cancel")} size="small" />
      </Link>
    </form>
  );
}
